import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  .story {\n    display: flex;\n    position: relative;\n    overflow: hidden;\n    align-items: center;\n  },\n  .storyContent {\n    width: auto;\n    max-width: 100%;\n    max-height: 100%;\n    margin: auto;\n  },\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
export var StoryStyled = styled.div.withConfig({
    componentId: "sc-7cfd1cf8-0"
})(_templateObject());
